import { Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface LocationStepProps {
  locations: { id: string; description: string }[]
  childName?: string
  onNext: () => void
}

export function LocationStep({ locations, childName, onNext }: LocationStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-center">
          Where did {childName || 'your baby'} sleep?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {locations.map((location) => (
            <Button
              key={location.id}
              type="button"
              variant={form.watch("location_id") === location.id ? "default" : "outline"}
              className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
              onClick={() => {
                form.setValue("location_id", location.id)
                form.clearErrors("location_id")
                onNext()
              }}
            >
              <Moon className="mr-2 h-4 w-4 shrink-0" />
              <span className="text-sm line-clamp-2">{location.description}</span>
            </Button>
          ))}
        </div>
        {form.formState.errors.location_id && (
          <p className="text-sm text-destructive">
            {form.formState.errors.location_id.message}
          </p>
        )}
      </div>
    </SleepStepContainer>
  )
}